import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;


const scrollReplacementConfig = {
    autoHide: false
};

function replaceScrollbar( selectorString, targetSelectorAttribute = "href" ) {
    if ( !selectorString ) { return; }
    const targets = [... document.querySelectorAll( selectorString )];
    if ( !targets ) { return; }

    targets.forEach( element => {
        new SimpleBar( element, scrollReplacementConfig );
    } );
}

export { replaceScrollbar };
